import React from "react";

const ScoreContext = React.createContext({
    randomId: 0,
    complianceRightAnswers: 0,
    memesRightAnswers: 0,
    email: '',
    increaseCompliance: () => { },
    increaseMemes: () => { },
    setEmail: (email) => { },
    generateRandomId: () => { } ,
    setTime: (time) => { }
})

export default ScoreContext;